import {
    CLUBS_FAILURE,
    CLUBS_PATCH_SUCCESS,
    CLUBS_POST_SUCCESS,
    CLUBS_REQUEST,
    CLUBS_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const clubListReducer = (state = initialState, action) => {
    const {type, data, club} = action;
    switch (type) {
        case CLUBS_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case CLUBS_PATCH_SUCCESS: {
            return {
                ...state,
                data: state.data.map(d => d.id === club.id ? club : d)
            }
        }

        case CLUBS_POST_SUCCESS: {return {
            ...state,
            data: [...state.data, club]
        }}

        case CLUBS_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case CLUBS_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
